import styled from 'styled-components/macro';

export const MakeList = styled.ul``;
